The subscriber-owned URL where events are sent to.
